import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const JackpotTable = styled.div`
  height: 800px;
  width: 100%;
  padding: 5px;
`;
export const JackpotSelect = styled(Select)`
  min-width: 180px;
`;

export const JackpotComboBox = styled.div`
  padding: 10px;
  display: inline;
`;
